import { TextAreaField } from '@sainsburys-tech/luna-form'
import { useComponentContext } from '../../ComponentContext'
import { IMultiLine } from '../../../../../types/ComponentTypes/Components'
import { useEffect, useState } from 'react'

function MultiLineInputComponent({ label, info,  id, error, placeholder, answer, defaultValue }: IMultiLine) {
  
  const [value, setValue] = useState(defaultValue !== '' ? defaultValue : answer || '')
  const { handleUpdate } = useComponentContext()
  const handleChange = (e: any) => {
    handleUpdate({ id, value: e.target.value })
    setValue(e.target.value)
  }

  useEffect(() => {
    if (value) {
      handleChange({ target: { value: value } });
    }
  }, [value]);

  return (
    <div id="s-reporting-multiline-input">
      <TextAreaField
        name={id}
        label={label}
        info={info}
        error={error}
        placeholder={placeholder}
        onChange={handleChange}
        value={value}
      />
    </div>
  )
}

export default MultiLineInputComponent
